// Module
var code = "<div class=\"red-text text-smaller remediation-policy-thermometer-warning stub\"> <i cs-icon=\"warningRed\" class=\"policy-icon-violations\"></i> </div> ";
// Exports
var _module_exports =code;;
var path = '/components/remediation-policy/remediation-policy-thermometer-warning-stub.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;